export function serializeJsonLd(payload: Record<string, unknown>): string {
  const clean = pruneEmpty(payload);
  return JSON.stringify(clean)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

function pruneEmpty(value: unknown): unknown {
  if (Array.isArray(value))
    return value
      .map(pruneEmpty)
      .filter((v) => v !== undefined && v !== null && v !== "");
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .map(([k, v]) => [k, pruneEmpty(v)])
        .filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
  }
  return value;
}
